import React, { FC } from "react";

import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@mui/material";

import { Communication } from "@/components/organisms/Forms";
import { CommunicationBaseFormType } from "@/components/organisms/Forms/Communication/formType";
import { phoneFormatter } from "@/core/phone";

import { formSchemaCommunication } from "./formSchema";

type ContactFormProps = {
    isSubmittable?: boolean;
    personDetails: MyBrokerApi.PersonalDetails;
    onSubmit: (data: any) => void;
};

export const defaultValues = (personDetails: MyBrokerApi.PersonalDetails): CommunicationBaseFormType => {
    return {
        phone0: phoneFormatter(personDetails?.contact?.phone0),
        phone1: phoneFormatter(personDetails?.contact?.phone1),
        phone2: phoneFormatter(personDetails?.contact?.phone2),
        typePhone0: personDetails?.contact?.typePhone0?.id || "",
        typePhone1: personDetails?.contact?.typePhone1?.id || "",
        typePhone2: personDetails?.contact?.typePhone2?.id || "",
        email0: personDetails?.contact?.email0 || "",
        email1: personDetails?.contact?.email1 || "",
    };
};

const ContactForm: FC<ContactFormProps> = ({ isSubmittable = true, personDetails = null, onSubmit }) => {
    const { t } = useTranslation();

    const methods = useForm<CommunicationBaseFormType>({
        mode: "onBlur",
        shouldUnregister: true,
        defaultValues: defaultValues(personDetails),
        resolver: yupResolver(formSchemaCommunication),
    });

    const {
        handleSubmit,
        formState: { isDirty },
    } = methods;

    const submitHandler = (formData: CommunicationBaseFormType) => {
        onSubmit({
            contact: {
                phone0: formData.phone0,
                phone1: formData.phone1,
                phone2: formData.phone2,
                typePhone0: { id: formData.phone0 ? formData.typePhone0 : "" },
                typePhone1: { id: formData.phone1 ? formData.typePhone1 : "" },
                typePhone2: { id: formData.phone2 ? formData.typePhone2 : "" },
                email0: formData.email0,
                email1: formData.email1,
            },
        });
    };

    return (
        <FormProvider {...methods}>
            <form className="contactForm" onSubmit={handleSubmit(submitHandler)}>
                <Communication />
                <Button disabled={!isDirty || !isSubmittable} type="submit" className="mt10" fullWidth>
                    {t("User.PersonalDetails.Submit")}
                </Button>
            </form>
        </FormProvider>
    );
};

export default ContactForm;
